import { Zap, Shield, TrendingUp, BarChart3 } from "lucide-react";

const AdvantagesSection = () => {
  const advantages = [
    {
      icon: <Zap className="w-6 h-6" />,
      title: "Lightning Fast",
      description: "Built for speed and efficiency. Complete your daily tasks in minutes, not hours."
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Secure & Reliable",
      description: "Your data is protected with enterprise-grade security. Regular backups ensure you never lose information."
    },
    {
      icon: <TrendingUp className="w-6 h-6" />,
      title: "Scalable Growth",
      description: "Start small and grow big. Our flexible plans adapt to your business needs as you expand."
    },
    {
      icon: <BarChart3 className="w-6 h-6" />,
      title: "Data-Driven Decisions",
      description: "Make informed decisions with comprehensive analytics and real-time insights into your business performance."
    }
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Why Choose StorePilot?
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Join thousands of businesses that trust StorePilot to manage their operations.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {advantages.map((advantage, index) => (
          <div
            key={index}
            className="text-center p-6 rounded-xl bg-white border border-gray-200 hover:shadow-lg transition"
          >
            <div className="text-primary mb-4 flex justify-center">{advantage.icon}</div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{advantage.title}</h3>
            <p className="text-gray-600 text-sm">{advantage.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdvantagesSection;

